var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsString, IsBoolean, IsOptional, ValidateNested, IsDate, IsNumber } from "class-validator";
import { Type } from "class-transformer";
import { willNeverHappen } from "./utils";
export var PatientDataVisualizationCategoryType;
(function (PatientDataVisualizationCategoryType) {
    PatientDataVisualizationCategoryType["CONDITIONS"] = "CONDITIONS";
    PatientDataVisualizationCategoryType["MEDICATIONS"] = "MEDICATIONS";
    PatientDataVisualizationCategoryType["LABS"] = "LABS";
    PatientDataVisualizationCategoryType["ALLERGIES"] = "ALLERGIES";
    PatientDataVisualizationCategoryType["PROCEDURES"] = "PROCEDURES";
    PatientDataVisualizationCategoryType["IMMUNIZATIONS"] = "IMMUNIZATIONS";
    PatientDataVisualizationCategoryType["CLINICAL_VISITS"] = "CLINICAL_VISITS";
})(PatientDataVisualizationCategoryType || (PatientDataVisualizationCategoryType = {}));
export var PatientDataVisualizationPdfStatus;
(function (PatientDataVisualizationPdfStatus) {
    PatientDataVisualizationPdfStatus["PENDING"] = "PENDING";
    PatientDataVisualizationPdfStatus["GENERATING"] = "GENERATING";
    PatientDataVisualizationPdfStatus["GENERATED"] = "GENERATED";
    PatientDataVisualizationPdfStatus["UPLOADING"] = "UPLOADING";
    PatientDataVisualizationPdfStatus["COMPLETED"] = "COMPLETED";
    PatientDataVisualizationPdfStatus["ERROR"] = "ERROR";
})(PatientDataVisualizationPdfStatus || (PatientDataVisualizationPdfStatus = {}));
export function getCategoryName(category) {
    switch (category) {
        case PatientDataVisualizationCategoryType.CONDITIONS:
            return "Conditions";
        case PatientDataVisualizationCategoryType.MEDICATIONS:
            return "Medications";
        case PatientDataVisualizationCategoryType.LABS:
            return "Labs";
        case PatientDataVisualizationCategoryType.ALLERGIES:
            return "Allergies";
        case PatientDataVisualizationCategoryType.PROCEDURES:
            return "Procedures";
        case PatientDataVisualizationCategoryType.IMMUNIZATIONS:
            return "Immunizations";
        case PatientDataVisualizationCategoryType.CLINICAL_VISITS:
            return "Clinical Visits";
        default:
            return willNeverHappen(category);
    }
}
export class PatientDataVisualizationBaseRecord {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationBaseRecord.prototype, "date", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationBaseRecord.prototype, "provider", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationBaseRecord.prototype, "name", void 0);
export class PatientDataVisualizationBaseCategory {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", String)
], PatientDataVisualizationBaseCategory.prototype, "category", void 0);
export class PatientDataVisualizationConditionsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationConditionsRecord.prototype, "notes", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientDataVisualizationConditionsRecord.prototype, "isActive", void 0);
export class PatientDataVisualizationConditions extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.CONDITIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationConditions.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationConditionsRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationConditions.prototype, "records", void 0);
export class PatientDataVisualizationMedicationsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationMedicationsRecord.prototype, "dosage", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationMedicationsRecord.prototype, "frequency", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientDataVisualizationMedicationsRecord.prototype, "isActive", void 0);
export class PatientDataVisualizationMedications extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.MEDICATIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationMedications.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationMedicationsRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationMedications.prototype, "records", void 0);
export class PatientDataVisualizationLabsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationLabsRecord.prototype, "value", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationLabsRecord.prototype, "referenceRange", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientDataVisualizationLabsRecord.prototype, "isOutOfRange", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientDataVisualizationLabsRecord.prototype, "referenceRangeIsApplicable", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationLabsRecord.prototype, "notes", void 0);
export class PatientDataVisualizationLabsSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationLabsSection.prototype, "section", void 0);
__decorate([
    Type(() => PatientDataVisualizationLabsRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationLabsSection.prototype, "records", void 0);
export class PatientDataVisualizationLabs extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.LABS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationLabs.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationLabsSection),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationLabs.prototype, "sections", void 0);
export class PatientDataVisualizationAllergiesRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationAllergiesRecord.prototype, "description", void 0);
export class PatientDataVisualizationAllergies extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.ALLERGIES;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationAllergies.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationAllergiesRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationAllergies.prototype, "records", void 0);
export class PatientDataVisualizationProceduresRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationProceduresRecord.prototype, "description", void 0);
export class PatientDataVisualizationProcedures extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.PROCEDURES;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationProcedures.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationProceduresRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationProcedures.prototype, "records", void 0);
export class PatientDataVisualizationImmunizationsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationImmunizationsRecord.prototype, "fullName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationImmunizationsRecord.prototype, "description", void 0);
export class PatientDataVisualizationImmunizations extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.IMMUNIZATIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationImmunizations.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationImmunizationsRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationImmunizations.prototype, "records", void 0);
export class PatientDataVisualizationClinicalVisitsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationClinicalVisitsRecord.prototype, "description", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], PatientDataVisualizationClinicalVisitsRecord.prototype, "diagnoses", void 0);
export class PatientDataVisualizationClinicalVisits extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.CLINICAL_VISITS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", Object)
], PatientDataVisualizationClinicalVisits.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationClinicalVisitsRecord),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationClinicalVisits.prototype, "records", void 0);
export class PatientDataVisualizationSnapshotCategoryDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", String)
], PatientDataVisualizationSnapshotCategoryDto.prototype, "category", void 0);
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationSnapshotCategoryDto.prototype, "records", void 0);
export class PatientDataVisualizationDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientDataVisualizationDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationDto.prototype, "name", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationDto.prototype, "dob", void 0);
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationDto.prototype, "providers", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationDto.prototype, "providersSince", void 0);
__decorate([
    Type(() => PatientDataVisualizationBaseCategory, {
        discriminator: {
            property: "category",
            subTypes: [
                { value: PatientDataVisualizationConditions, name: PatientDataVisualizationCategoryType.CONDITIONS },
                { value: PatientDataVisualizationMedications, name: PatientDataVisualizationCategoryType.MEDICATIONS },
                { value: PatientDataVisualizationLabs, name: PatientDataVisualizationCategoryType.LABS },
                { value: PatientDataVisualizationAllergies, name: PatientDataVisualizationCategoryType.ALLERGIES },
                { value: PatientDataVisualizationProcedures, name: PatientDataVisualizationCategoryType.PROCEDURES },
                { value: PatientDataVisualizationImmunizations, name: PatientDataVisualizationCategoryType.IMMUNIZATIONS },
                { value: PatientDataVisualizationClinicalVisits, name: PatientDataVisualizationCategoryType.CLINICAL_VISITS },
            ],
        },
    }),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationDto.prototype, "categories", void 0);
export class PatientDataVisualizationLiteCategoryDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType),
    __metadata("design:type", String)
], PatientDataVisualizationLiteCategoryDto.prototype, "category", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientDataVisualizationLiteCategoryDto.prototype, "total", void 0);
export class PatientDataVisualizationLiteDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientDataVisualizationLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientDataVisualizationLiteDto.prototype, "name", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientDataVisualizationLiteDto.prototype, "dob", void 0);
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationLiteDto.prototype, "providers", void 0);
__decorate([
    Type(() => PatientDataVisualizationLiteCategoryDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientDataVisualizationLiteDto.prototype, "categories", void 0);
export const mockPatientDataVisualizationLiteDto = new PatientDataVisualizationLiteDto({
    createdAt: new Date(),
    name: "Camila Maria Lopez",
    dob: new Date("1964-03-21"),
    providers: ["Mountain View General Hosptial", "Oxbridge Health", "Acme Health"],
    categories: [
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.CONDITIONS,
            total: 7,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.MEDICATIONS,
            total: 5,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.LABS,
            total: 130,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.ALLERGIES,
            total: 27,
        }),
    ],
});
export const mockPatientDataVisualizationDto = new PatientDataVisualizationDto({
    createdAt: new Date(),
    name: "Camila Maria Lopez",
    dob: new Date("1987-11-09"),
    providers: ["Mountain View General Hosptial", "Oxbridge Health", "Acme Health"],
    providersSince: new Date("2015-12-01"),
    categories: [
        new PatientDataVisualizationConditions({
            category: PatientDataVisualizationCategoryType.CONDITIONS,
            records: [
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Polycystic ovaries",
                    notes: "Sample Notes",
                    date: new Date(),
                    isActive: true,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Type 2 Diabetes",
                    date: new Date(),
                    isActive: true,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Hypertension",
                    date: new Date(),
                    isActive: false,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Asthma",
                    date: new Date(),
                    isActive: true,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Seasonal Allergic Rhinitis",
                    date: new Date(),
                    isActive: false,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Hyperthyroidism",
                    notes: "Discussed potential long-term treatments including radioactive iodine ablation vs. surgery if persistent. Follow-up in 6 weeks with repeat thyroid function labs.",
                    date: new Date(),
                    isActive: true,
                }),
                new PatientDataVisualizationConditionsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Osteoarthritis (Right knee)",
                    date: new Date(),
                    isActive: false,
                }),
            ],
        }),
        new PatientDataVisualizationMedications({
            category: PatientDataVisualizationCategoryType.MEDICATIONS,
            records: [
                new PatientDataVisualizationMedicationsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Metamorfin",
                    date: new Date(),
                    isActive: true,
                    dosage: "Sample Dosage",
                    frequency: "Sample Frequency",
                }),
                new PatientDataVisualizationMedicationsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Spironolactone",
                    date: new Date(),
                    isActive: true,
                    dosage: "Sample Dosage",
                    frequency: "Sample Frequency",
                }),
                new PatientDataVisualizationMedicationsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Lisinopril",
                    date: new Date(),
                    isActive: false,
                    dosage: "Sample Dosage",
                    frequency: "Sample Frequency",
                }),
                new PatientDataVisualizationMedicationsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Levothyroxine",
                    date: new Date(),
                    isActive: true,
                    dosage: "Sample Dosage",
                    frequency: "Sample Frequency",
                }),
                new PatientDataVisualizationMedicationsRecord({
                    provider: "Mountain View General Hosptial",
                    name: "Atorvastin",
                    date: new Date(),
                    isActive: true,
                    dosage: "Sample Dosage",
                    frequency: "Sample Frequency",
                }),
            ],
        }),
        new PatientDataVisualizationLabs({
            category: PatientDataVisualizationCategoryType.LABS,
            sections: [
                new PatientDataVisualizationLabsSection({
                    section: "Red Blood Cell Count #1",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Comprehensive Metabolic Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Lipid Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Glucose #1",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "CBC Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Vitamin D",
                            date: new Date("2025-09-01"),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid Stimulating Hormone",
                            date: new Date("2025-06-01"),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Total Cholesterol #1",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Hemoglobin A1c",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            notes: "Your cholesterol is mildly elevated. Recommend continuing dietary modifications and exercise. We will recheck in 6 months.",
                            isOutOfRange: false,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Vitamin D",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid Stimulating Hormone",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Red Blood Cell Count #2",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Comprehensive Metabolic Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Lipid Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            notes: "Your cholesterol is mildly elevated. Recommend continuing dietary modifications and exercise. We will recheck in 6 months.",
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Glucose #2",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "CBC Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Vitamin D",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid Stimulating Hormone",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Total Cholesterol #2",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Hemoglobin A1c",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Vitamin D",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid Stimulating Hormone",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Red Blood Cell Count #3",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Comprehensive Metabolic Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Lipid Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: false,
                        }),
                    ],
                }),
                new PatientDataVisualizationLabsSection({
                    section: "Glucose #3",
                    records: [
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "CBC Panel",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Vitamin D",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                        new PatientDataVisualizationLabsRecord({
                            provider: "Oxbridge Health",
                            name: "Thyroid Stimulating Hormone",
                            date: new Date(),
                            value: "Sample Dosage",
                            referenceRange: "Sample Reference Range",
                            referenceRangeIsApplicable: true,
                            isOutOfRange: true,
                        }),
                    ],
                }),
            ],
        }),
        new PatientDataVisualizationAllergies({
            category: PatientDataVisualizationCategoryType.ALLERGIES,
            records: [
                new PatientDataVisualizationAllergiesRecord({
                    provider: "Oxbridge Health",
                    name: "Penicillin",
                    date: new Date(),
                    description: "Sample Description",
                }),
                new PatientDataVisualizationAllergiesRecord({
                    provider: "Oxbridge Health",
                    name: "Aspirin",
                    date: new Date(),
                    description: "Sample Description",
                }),
            ],
        }),
        new PatientDataVisualizationProcedures({
            category: PatientDataVisualizationCategoryType.PROCEDURES,
            records: [
                new PatientDataVisualizationProceduresRecord({
                    provider: "Oxbridge Health",
                    name: "Knee Arthroscopy",
                    date: new Date(),
                    description: "Right knee, meniscus repair",
                }),
            ],
        }),
        new PatientDataVisualizationImmunizations({
            category: PatientDataVisualizationCategoryType.IMMUNIZATIONS,
            records: [
                new PatientDataVisualizationImmunizationsRecord({
                    provider: "Mountain View General Hospital",
                    name: "DTaP",
                    fullName: "Diphtheria, Tetanus, Pertussis",
                    date: new Date(),
                }),
                new PatientDataVisualizationImmunizationsRecord({
                    provider: "Mountain View General Hospital",
                    name: "MMR",
                    fullName: "Measles, Mumps, Rubella",
                    description: "Childhood series",
                    date: new Date(),
                }),
                new PatientDataVisualizationImmunizationsRecord({
                    provider: "Mountain View General Hospital",
                    name: "HPV",
                    date: new Date(),
                }),
            ],
        }),
        new PatientDataVisualizationClinicalVisits({
            category: PatientDataVisualizationCategoryType.CLINICAL_VISITS,
            records: [
                new PatientDataVisualizationClinicalVisitsRecord({
                    provider: "Mountain View General Hospital",
                    name: "Office Visit",
                    date: new Date(),
                    description: "Primary Care",
                }),
                new PatientDataVisualizationClinicalVisitsRecord({
                    provider: "Mountain View General Hospital",
                    name: "Hospital Outpatient Visit",
                    date: new Date(),
                }),
                new PatientDataVisualizationClinicalVisitsRecord({
                    provider: "Mountain View General Hospital",
                    name: "Procedure Visit",
                    date: new Date(),
                    description: "Operating Room",
                    diagnoses: ["Inflamed appendix"],
                }),
            ],
        }),
    ],
});
